import { Component, Input, ChangeDetectorRef } from '@angular/core';
import { BehaviorSubject, combineLatest } from 'rxjs';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { filter, map } from 'rxjs/operators';
import { App } from '../../../interfaces/app';
import { IPreparedFile } from '../../../services/file-upload.service';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@UntilDestroy()
@Component({
  selector: 'app-app-config-device',
  templateUrl: './app-config-device.component.html',
  styleUrls: ['./app-config-device.component.scss'],
})
export class AppConfigDeviceComponent {

  @Input()
  public set app(value: App | undefined) {
    this.appSubject.next(value);
  }

  @Input()
  public set config(value: unknown) {
    this.configSubject.next(value);
  }

  @Input()
  public set files(value: IPreparedFile[]) {
    this.filesSubject.next(value);
  }

  public url: SafeResourceUrl | undefined = undefined;

  public appSubject = new BehaviorSubject<App | undefined>(undefined);
  public configSubject = new BehaviorSubject<unknown>(undefined);
  public filesSubject = new BehaviorSubject<IPreparedFile[]>([]);

  public tableInfoSubject = combineLatest([
    this.appSubject,
    this.configSubject,
    this.filesSubject,
  ]).pipe(
    filter(([app, config]) => !!app && !!config),
    map(([app, config, files]) => ({
      app: {
        id: app?.id,
        name: app?.name,
        vendor: app?.vendor,
        instance: {
          id: 'demo-instance',
          schemeVersion: app?.configSchemeVersion,
          config,
          files,
        },
      },

      // @TODO Remove after remove widgetUIConfig functionality.
      widgetUIConfig: {
        callWaiterButtons: {
          callWaiter: { enabled: true, name: '', lightsColor: null },
          requestBill: { enabled: true, name: '', lightsColor: null },
          anotherRound: { enabled: true, name: '', lightsColor: null },
        }
      },
    })),
  );

  constructor(
    private readonly changeDetectorRef: ChangeDetectorRef,
    private readonly sanitizer: DomSanitizer,
  ) {
    this.appSubject.pipe(
      untilDestroyed(this),
    ).subscribe((app) => {
      if (!app) {
        return;
      }

      const url = new URL(app.url);
      url.searchParams.set('startupMode', 'demo');

      this.url = this.sanitizer.bypassSecurityTrustResourceUrl(url.toString());
      this.changeDetectorRef.detectChanges();
    });
  }

}
